import React from 'react';

import {useTheme, useLegalInfo, useI18n} from 'pageflow-scrolled/frontend';

import styles from './WdrFooter.module.css';

export function WdrFooter() {
  const theme = useTheme();
  const legalInfo = useLegalInfo();
  const {t} = useI18n();

  const items = [
    {kind: 'imprint'},
    {url: 'https://www1.wdr.de/hilfe/datenschutz102.html', label: 'Datenschutz'},
    {url: 'https://www1.wdr.de/kontakt/index.html', label: 'Kontakt'},
    {kind: 'copyright'},
  ];

  function renderLinkOrButton(item) {
    if (legalInfo[item.kind]) {
      item = legalInfo[item.kind];
    }

    return (
      <a className={styles.link}
         href={item.url}
         dangerouslySetInnerHTML={{__html: item.label}} />
    );
  }
  return (
    <div className={styles.bar}>
      <ul className={styles.items}>
        {items.map((item, index) =>
          <li key={index} className={styles.item}>
            {renderLinkOrButton(item)}
          </li>
        )}
      </ul>
    </div>
  );
}
